import React from 'react';
import { connect } from 'react-redux';

import * as selectors from './selectors';

import Notification from './Notification';

const NotificationConnected = (props) => <Notification {...props} />;

const mapStateToProps = (state) => ({
  notificationOptions: selectors.selectNotificationOptions(state),
  type: selectors.selectType(state),
});

export default connect(mapStateToProps)(NotificationConnected);
